export default {"src":"/_next/static/media/yamaha.9aa41552.svg","height":46,"width":160,"blurWidth":0,"blurHeight":0};